const BlockOutCalendarSVG = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.75 8.625V6.6C15.75 5.33988 15.75 4.70982 15.5048 4.22852C15.289 3.80516 14.9448 3.46095 14.5215 3.24524C14.0402 3 13.4101 3 12.15 3H5.85C4.58988 3 3.95982 3 3.47852 3.24524C3.05516 3.46095 2.71095 3.80516 2.49524 4.22852C2.25 4.70982 2.25 5.33988 2.25 6.6V12.9C2.25 14.1601 2.25 14.7902 2.49524 15.2715C2.71095 15.6948 3.05516 16.039 3.47852 16.2548C3.95982 16.5 4.58988 16.5 5.85 16.5H9.375M15.75 7.5H2.25M12 1.5V4.5M6 1.5V4.5M13.5 15.75V11.25M11.25 13.5H15.75"
      stroke="#EA1C1C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BlockOutCalendarSVG;
